import React from 'react';
import { useTranslation } from 'react-i18next';

const Procedure = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: "01",
      key: "1"
    },
    {
      number: "02",
      key: "2"
    },
    {
      number: "03",
      key: "3"
    },
    {
      number: "04",
      key: "4"
    }
  ];

  return (
    <section className="py-20 relative">
      {/* Background Image */}
      <div 
        className="absolute inset-0 w-full h-full bg-cover bg-center"
        style={{ 
          backgroundImage: 'url(/images/bgnavy.png)',
        }}
      />
      
      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Two Column Header */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          {/* Left Column */}
          <div>
            <div className="flex items-center">
                <div className="w-4 h-4 rounded-full bg-primaryBlue flex-shrink-0"></div>
                <h6 className="text-sm sm:text-md font-medium text-white ltr:ml-2 rtl:mr-2">{t('procedure.subtitle')}</h6>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mt-5 text-white whitespace-pre-line">
              {t('procedure.title')}
            </h2>
          </div>
          
          {/* Right Column */}
          <div className="pb-8 border-b border-white/20">
          </div>
        </div>

        {/* Process Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          {steps.map((step) => (
            <div 
              key={step.key}
              className="bg-primaryNavy backdrop-blur-sm rounded-2xl p-8 transition-transform duration-300"
            >
              <div className="flex flex-col space-y-3 mb-6">
                <span className="text-3xl sm:text-4xl font-semibold text-white/30">
                  {step.number}
                </span>
                <h3 className="text-lg sm:text-xl font-medium text-white leading-relaxed whitespace-pre-line">
                  {t(`procedure.steps.${step.key}.title`)}
                </h3>
              </div>
              <p className="text-sm sm:text-base text-gray-300">
                {t(`procedure.steps.${step.key}.description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Procedure; 